import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { HouseAction } from '@stores/house/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL, qrcodeImage, qrcodeLetter } from '@images/imageUrls';
import Toast from '@components/Toast';
import { getUrlParams } from '@utils/getUrlParams';
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// 导入 Swiper 样式
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { px2rem } from '@utils/px2rem'
import html2canvas from 'html2canvas';
interface HouseCardH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    house?: HouseAction;
}
interface HouseCardH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    houseInfo: any
    loadingArray: any
    step: any
    cardStatus: any
    sharePosterPopupStatus: any
    routerRotate: any
    posterImage: string
    posterLoaded: boolean
    base64Images: any
    base64ImagesLoaded: boolean
    posterGenerating: boolean
    routerSource?: any
    readyStatus: any
    saveToastStatus: boolean
    downloadAppStatus: boolean; // 是否显示下载入口，用来记录下载入口的初始化状态，返回到其他页面后恢复下载入口的显示状态
    headerShowStatus: boolean;  // 是否显示header，用来记录header的初始化状态，返回到其他页面后恢复header的显示状态
    isDeadline: boolean;    // 是否到截止日期2026年9月5日，如果到截止日期，按钮显示逻辑调整
}
@inject('app', 'site', 'user', 'house')
@observer
class HouseCardH5Page extends BasePage<HouseCardH5PageProps, HouseCardH5State> {
    private deadlineTimer: NodeJS.Timeout | null = null;
    // 处理图片加载错误
    handleImageError: React.ReactEventHandler<HTMLImageElement> = (event) => {
        const imgElement = event.currentTarget;
        imgElement.src = `${BASE_IMG_URL}/common/avatar.png`;
        // 防止默认图也加载失败时陷入死循环
        imgElement.onerror = null;
    };
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        houseInfo: null,  // 房产证信息
        loadingArray: [
            { step: 0, text: '正在为你分配...' },
            { step: 1, text: '正在为你分配...' },
            { step: 2, text: '正在为你分配...' },
            { step: 3, text: '正在为你分配...' },
        ],   // 房产证按钮进度
        step: 0,    // 第几步，1是初始化还未领取, 2是房产证一准备好，待领取（显示领取按钮）， 3是已领取（显示房产证信息）
        cardStatus: false,  // 房产证显示状态，false是正面（蓝色）， true是反面（房产证信息页）
        sharePosterPopupStatus: false,  // 是否显示海报
        routerRotate: 0,    // 路由参数，用来判断是否直接显示房产证信息
        posterImage: '',
        posterLoaded: false,
        base64Images: {},
        base64ImagesLoaded: false,
        posterGenerating: false,
        routerSource: '',   // 路由上的source参数
        readyStatus: false, // 数据是否已加载完成
        saveToastStatus: false, // 截图保存提示是否显示
        downloadAppStatus: false, // 是否显示下载入口
        headerShowStatus: false,  // 是否显示header
        isDeadline: false,  // 是否到截止日期了
    }
    componentDidMount() {
        super.componentDidMount();
        const { site, house, user } = this.props;
        if (site) {
            this.setState({
                downloadAppStatus: site.getAppDownloadShowStatus(),
                headerShowStatus: site.getShowHeader(),

            }, () => {
                site.setShowHeader(false);
                site.setAppDownloadShowStatus(false);
            })
        }
        this.getHouseDetail();

        // 最简单的版本：立即执行，然后每秒执行
        const updateStatus = () => {
            this.setState({ isDeadline: this.checkDeadline() });
        };

        // 立即执行一次
        updateStatus();

        // 每秒执行一次
        this.deadlineTimer = setInterval(updateStatus, 1000);

    }
    componentWillUnmount(): void {
        let { downloadAppStatus, headerShowStatus} = this.state;
        const { site } = this.props;
        if(site) {
            site.setShowHeader(headerShowStatus);
            site.setAppDownloadShowStatus(downloadAppStatus);
        }
        // 清除定时器
        if (this.deadlineTimer) {
            clearInterval(this.deadlineTimer);
            this.deadlineTimer = null;
            // console.log('定时器已清除');
        }
    }


    // 检查截止日期的工具方法
    checkDeadline = (): boolean => {
        const now = new Date();
        const deadline = new Date(2026, 8, 5, 0, 0, 0); // 2026年9月5日0:0:0
        
        // 调试输出
        // console.log('检查截止时间:', {
        //     当前时间: now.toLocaleString(),
        //     截止时间: deadline.toLocaleString(),
        //     是否截止: now >= deadline,
        //     时间戳: {
        //         当前: now.getTime(),
        //         截止: deadline.getTime(),
        //         差值: deadline.getTime() - now.getTime()
        //     }
        // });
        
        return now >= deadline;
    };



    isWeixin() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('micromessenger') !== -1;
    }
    getHouseDetail = () => {
        const { house, user } = this.props;
        const routerParams = new URLSearchParams(this.props.location.search);
        console.log(routerParams, 'routerParams路由参数');
        let rotate: any = '';
        // 统一使用 user.checkLogin() 判断登录，checkLogin 会在未登录时处理跳转
        if (user && typeof user.checkLogin === 'function') {
            const isLogin = user.checkLogin();
            if (isLogin) {
                rotate = routerParams?.get('rotate') || '';
                // console.log(routerParams?.get('rotate'), '需要旋转', rotate == '1' ? true : false);
                this.setState({
                    cardStatus: rotate == '1' ? true : false
                });
            }
        }
        const source: any = routerParams?.get('source') || '';
        this.setState({
            routerSource: source
        })
        if (house) {
            house.getHouseCert().then(res => {
                // console.log('获取房产证信息', res.data?.is_issued);
                if (res.code == 0) {
                    if (res.data?.is_issued || rotate == 1) {   // 如果已领取，直接显示房产证信息
                        this.setState({
                            step: 3,
                            cardStatus: true
                        })
                    } else {  // 如果未领取，走领取流程
                        console.log('未领取');
                        const newTexts = [
                            `正在为你分配【${res.data?.building}栋】...`,
                            `正在为你分配【${res.data?.unit}单元】...`,
                            `正在为你分配【${res.data?.floor}楼】...`,
                            `正在为你分配【${res.data?.room}室】...`,
                        ];
                        this.setState(prevState => ({
                            loadingArray: prevState.loadingArray.map((item, index) => ({
                                ...item,
                                text: newTexts[index]
                            }))
                        }), () => {
                            setTimeout(() => {
                                this.setState({
                                    step: 2,
                                })
                            }, 2100)
                        });
                    }

                    this.setState({
                        houseInfo: res.data,
                        readyStatus: true
                    })
                } else if (res.code == '-4004') {    // 尚未生成房产证
                    if (source == 'app') {
                        this.props.history.push(`/houseLetter?source=app`)
                    } else {
                        this.props.history.push(`/houseLetter`)
                    }
                }
            })
        }
    }

    // 领取房产证
    reciveHouseCard = () => {
        const { site, house } = this.props;
        if (house) {
            house.houseCertClaim().then(res => {
                console.log('领取房产证', res);
                if (res.code == 0) {
                    this.setState({
                        cardStatus: true,
                        step: 3
                    })
                    Toast.info({ content: '领取成功' })
                    this.getHouseDetail()
                }
            })
        }
    }

    // 单个图片转base64
    convertToBase64 = (url: string): Promise<string> => {
        return new Promise((resolve, reject) => {
            const image = new window.Image();
            image.crossOrigin = 'Anonymous';
            image.src = url + '?t=' + new Date().getTime();
            image.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    canvas.width = image.width;
                    canvas.height = image.height;
                    ctx.drawImage(image, 0, 0);
                    const base64 = canvas.toDataURL();
                    resolve(base64);
                } else {
                    reject(new Error('无法获取canvas上下文'));
                }
            };
            image.onerror = (error) => {
                reject(error);
            };
        });
    }

    // 批量转base64
   convertAllImagesToBase64 = async (houseInfo: any) => {
    console.log('=== convertAllImagesToBase64 被调用 ===', houseInfo);
    if (this.state.posterGenerating) {
        return;
    }
    this.setState({ posterGenerating: true });
    const base64Images: any = {};

    // 首先转换默认头像，确保一定有兜底
    try {
        const defaultAvatarBase64 = await this.convertToBase64(`${BASE_IMG_URL}/common/avatar.png`);
        base64Images['defaultAvatar'] = defaultAvatarBase64;
        console.log('默认头像转换成功');
    } catch (e) {
        console.error('默认头像转换失败', e);
    }

    // 其他图片URL
    const imageUrls = {
        bg9: `${BASE_IMG_URL}/house/bg21.png`,
        icon4: houseInfo?.user?.avatar,
        img2: `${BASE_IMG_URL}/house/img2.png`,
        img3: `${BASE_IMG_URL}/house/img3.png`,
        downloadCode: qrcodeLetter.code,
        userAvatar: houseInfo?.user?.avatar,
        bg2: `${BASE_IMG_URL}/house/bg2.png`,
        bg15: `${BASE_IMG_URL}/house/bg15.png`,
        bg8: `${BASE_IMG_URL}/house/bg22.png`,
        bg4: `${BASE_IMG_URL}/house/bg4.png`,
        bg6: `${BASE_IMG_URL}/house/bg6.png`
    };

    const entries = Object.entries(imageUrls);
    for (const [key, url] of entries) {
        // 如果头像URL为空，直接使用默认头像
        if ((key === 'icon4' || key === 'userAvatar') && !url) {
            base64Images[key] = base64Images['defaultAvatar'] || `${BASE_IMG_URL}/common/avatar.png`;
            continue;
        }
        
        if (!url) continue;
        try {
            base64Images[key] = await this.convertToBase64(url);
            console.log(`成功转换图片: ${key}`);
        } catch (e) {
            console.error(`转换图片失败: ${key}`, e);
            // 如果是头像，使用默认头像
            if (key === 'icon4' || key === 'userAvatar') {
                base64Images[key] = base64Images['defaultAvatar'] || `${BASE_IMG_URL}/common/avatar.png`;
            } else {
                base64Images[key] = url;
            }
        }
    }

    this.setState({
        base64Images,
        base64ImagesLoaded: true
    }, () => {
        this.generatePoster(true);
    });
}

    // 生成海报
    generatePoster = (imagesReady: boolean = false) => {
        console.log('=== generatePoster 被调用 ===');
        console.log('base64ImagesLoaded:', this.state.base64ImagesLoaded, 'imagesReady:', imagesReady);
        // 如果传入imagesReady为true，说明是从convertAllImagesToBase64回调中调用的，图片已准备好
        if (!imagesReady && !this.state.base64ImagesLoaded) {
            Toast.info({ content: '图片准备中，请稍候...' });
            const checkLoaded = () => {
                if (this.state.base64ImagesLoaded) {
                    this.generatePoster(true);
                } else {
                    setTimeout(checkLoaded, 300);
                }
            };
            checkLoaded();
            return;
        }

        Toast.loading({ content: '海报生成中···' });

        setTimeout(() => {
            const targetElement = document.getElementById('posterTarget');
            if (!targetElement) {
                Toast.hide();
                Toast.info({ content: '生成失败，请重试' });
                return;
            }

            html2canvas(targetElement, {
                useCORS: true,
                allowTaint: true,
                scale: 2,
                backgroundColor: null // 透明背景
            }).then(canvas => {
                const image = canvas.toDataURL('image/png');
                Toast.hide(); // 隐藏loading
                this.setState({
                    posterImage: image,
                    posterLoaded: true
                }, () => {
                    // 必须在setState回调中调用，确保posterImage已更新
                    this.handleSaveImage().then(() => {
                        // 已在 handleSaveImage 中重置 posterGenerating
                    }).catch(() => {
                        // 保底重置
                        this.setState({ posterGenerating: false });
                    });
                });
            }).catch(error => {
                console.error('生成海报失败:', error);
                Toast.hide(); // 隐藏loading
                Toast.info({ content: '海报生成失败，请重试' });
                this.setState({ posterGenerating: false });
            });
        }, 1000);
    }

    // 保存海报图片
    handleSaveImage = (): Promise<void> => {
        return new Promise((resolve) => {
            console.log('=== handleSaveImage 被调用 ===');
            const { posterImage } = this.state;
            console.log('posterImage:', posterImage);

            if (!posterImage) {
                console.log('posterImage 为空，提示用户等待');
                Toast.info({ content: '图片生成中，请稍后' });
                this.setState({ posterGenerating: false });
                resolve();
                return;
            }

            console.log('开始保存图片...');
            const link = document.createElement('a');
            link.href = posterImage;
            link.download = `house-card-poster-${Date.now()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            console.log('图片保存完成');

            Toast.success({ content: '图片已保存' });
            // 保存完成，允许再次生成并关闭海报弹框
            this.setState({ posterGenerating: false, sharePosterPopupStatus: false, posterLoaded: false }, () => resolve());
        });
    }

    // 获取图片URL - 优先使用base64图片
    getImage = (key: string) => {
        const { base64Images, base64ImagesLoaded, houseInfo } = this.state;
        if (base64ImagesLoaded && base64Images[key]) {
            return base64Images[key];
        }
        // 根据key返回对应的原始图片
        const imageMap: any = {
            bg9: `${BASE_IMG_URL}/house/bg9.png`,
            icon4: houseInfo?.user?.avatar || `${BASE_IMG_URL}/common/avatar.png`,
            img2: `${BASE_IMG_URL}/house/img2.png`,
            img3: `${BASE_IMG_URL}/house/img3.png`,
            downloadCode: qrcodeLetter.code,
            bg2: `${BASE_IMG_URL}/house/bg2.png`,
            bg15: `${BASE_IMG_URL}/house/bg15.png`,
            bg8: `${BASE_IMG_URL}/house/bg8.png`,
            bg4: `${BASE_IMG_URL}/house/bg4.png`,
            bg6: `${BASE_IMG_URL}/house/bg6.png`
        };
        return imageMap[key] || '';
    }
    // 截图保存，自定义toast
    saveToast = () => {
        return (
            <div className={styles.saveToastBox}>
                <div className={styles.saveToast}>
                    <img src={`${BASE_IMG_URL}/house/icon12.png`} alt="" className={styles.saveIcon}/>
                    <div className={styles.saveText}>截图保存邀请好友参加</div>
                </div>
            </div>
            
        );
    }

    render() {
        let { houseInfo, sharePosterPopupStatus, loadingArray, step, cardStatus, routerRotate, posterImage, posterLoaded, routerSource, readyStatus, saveToastStatus, isDeadline } = this.state;
        // console.log(step, '步骤', cardStatus, routerRotate, '旋转');
        console.log(routerSource, 'source参数', this.isWeixin())
        return (
            <>

                {readyStatus && <div className={classNames(styles.houseWrap, sharePosterPopupStatus ? styles.fixedWrap : '')} style={{paddingBottom: this.isWeixin() ? px2rem(80) : px2rem(24)}}>
                    <div className={styles.houseHeader} style={{paddingTop: routerSource == 'app' ? px2rem(80) : px2rem(20)}}>
                        <img src={`${BASE_IMG_URL}/house/back.png`} alt="" className={styles.close} onClick={() => {
                            if (routerSource == 'app') {  // 如果是app打开，调用app给的js方法
                                // js_normal.onBackClick()
                            } else {  // 回到首页
                                window.ensureBack(
                                    () => {
                                        //   console.log('返回完成');
                                    }
                                );
                                let { site } = this.props;
                                if (site) {
                                    site.setShowHeader(true);
                                }
                            }
                        }} />
                    </div>
                    <div className={styles.userDetail}>
                        <div className={styles.userAvatarBox}>
                            <img src={houseInfo?.user?.avatar || `${BASE_IMG_URL}/common/avatar.png`} onError={this.handleImageError} alt="用户头像" className={styles.userAvatar} />
                            {/* 黑色官方标识 */}
                            {houseInfo?.user?.titleMark == 2 && <img src={`${BASE_IMG_URL}/common/official1.png`} alt="" className={styles.official} />}
                            {/* 蓝色官方标识 */}
                            {houseInfo?.user?.titleMark == 1 && <img src={`${BASE_IMG_URL}/common/official2.png`} alt="" className={styles.official} />}
                        </div>

                        <div className={styles.userRanking}>你是第<span>&nbsp;{houseInfo?.id}&nbsp;</span>位业主</div>
                    </div>
                    <div className={styles.houseCardBox} onClick={() => {
                        if (houseInfo.is_issued) {
                            this.setState({
                                cardStatus: !cardStatus,
                                routerRotate: 0,
                                // step: !cardStatus ? 3 : 2
                            })
                        }

                    }}>
                        <div className={classNames(styles.flipCard, cardStatus ? styles.flipRotate : styles.flipRotate0)}>
                            <img src={`${BASE_IMG_URL}/house/bg9.png`} alt="" className={classNames(styles.obverseImg, styles.flipFront)} />
                            <div className={classNames(styles.houseCardInfo, styles.flipBack)}>
                                <div className={styles.cardNum}>不动产权第 {houseInfo?.id} 号</div>
                                <img src={houseInfo?.user?.avatar || `${BASE_IMG_URL}/common/avatar.png`} onError={this.handleImageError} alt="用户头像" className={styles.userAvatar} />
                                <div className={styles.gap}>• 权利人 •</div>
                                <div className={styles.info}>{houseInfo?.user?.nickname}</div>
                                <div className={styles.gap}>• 坐落 •</div>
                                <div className={styles.info}>vivo社区APP <span>{houseInfo?.building}</span> 栋 <span>{houseInfo?.unit}</span> 单元 <span>{houseInfo?.floor}</span> 楼 <span>{houseInfo?.room}</span> 室</div>
                                <div className={styles.gap}>• 使用期限 •</div>
                                <div className={styles.info}>{houseInfo?.issued_at}-永久</div>
                                <div className={styles.cardBottom}>
                                    <div className={styles.codeBox}>
                                        <div className={styles.downloadCodeBox}>
                                            <img src={qrcodeImage.qrcodeVshop} alt="" className={styles.code} />
                                        </div>

                                        <div className={styles.bottomInfo}>
                                            <div className={styles.text}>发证方（章）</div>
                                            <div className={styles.text}>{houseInfo?.issued_at}</div>
                                        </div>
                                    </div>
                                    <img src={`${BASE_IMG_URL}/house/img3.png`} alt="" className={styles.chapter} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*未领取， 生成房产证按钮 */}
                    {(!houseInfo?.is_issued && step != 2 && step != 3) && <div className={styles.creatCardBtn}>
                        <div className={styles.btnProgress}></div>
                        <div className={styles.btnContent}>
                            <Swiper
                                modules={[Autoplay]}
                                loop={false}
                                autoplay={{
                                    delay: 100,  // 100毫秒轮播一次
                                    pauseOnMouseEnter: false, // 鼠标悬停时不暂停
                                }}
                                speed={400}
                                allowSlidePrev={false}  // 禁止向前/向上回滚
                                direction="vertical"
                                style={{ width: '100%', height: px2rem(92) }}
                                onSlideChange={() => console.log('slide change')}
                            >
                                {loadingArray.map((item: any, index: any) => (
                                    <SwiperSlide key={index}>
                                        {item.text}
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>}

                    {/* 已生成，未领取 */}
                    {(!houseInfo?.is_issued && step == 2) && <div className={styles.creatPoster} onClick={() => this.reciveHouseCard()}>
                        房产证已准备好，点击领取
                    </div>}

                    {/* 已领取，显示分享按钮 */}
                    {(houseInfo?.is_issued && step == 3) && <>
                        <div className={styles.bottomBtnBox} style={{marginTop: isDeadline ? '0' : ''}}>
                            <div className={classNames(styles.showCradBtn, isDeadline ? styles.creatPoster : '')} onClick={() => {
                                if (!this.isWeixin()) {  // 如果不是微信内打开
                                    this.setState({
                                        sharePosterPopupStatus: true
                                    })
                                } else {    // 如果是微信内打开
                                    this.setState({
                                        sharePosterPopupStatus: true,
                                        saveToastStatus: true
                                    }, () => {
                                        setTimeout(() => {
                                            this.setState({
                                                saveToastStatus: false
                                            })
                                        }, 3000)
                                    })
                                }
                            }}>晒房产证</div>
                            {!isDeadline && <div className={styles.showCradBtn} onClick={() => {
                                if(routerSource != 'app') {
                                    window.open(`https://m.malink.cn/s/ABbE73`)
                                } else {
                                    window.location.href = `vivoclub://com.vivo.club/deep?page=thread_detail&type=0&id=123100`
                                }
                                
                            }}>去抽X300</div>}
                        </div>
                        
                        {saveToastStatus && this.saveToast()}
                        {!isDeadline && <>
                            {routerSource != 'app' && <div className={styles.downloadAppEnter}>
                                <div className={styles.left}>
                                    <img src={`${BASE_IMG_URL}/house/img8.png`} alt="" className={styles.icon} />
                                    <div className={styles.info}>
                                        <div className={classNames(styles.text)}>下载App查看</div>
                                        <div className={classNames(styles.text, styles.blue)}>vivo X300抽奖情况</div>
                                    </div>
                                </div>
                                <div className={styles.downloadAppBtn} onClick={() => {
                                    // this.props.history.push(`/downloadAppEnter`)
                                    window.open('https://m.malink.cn/s/ABbE73')
                                }}>立即下载</div>
                            </div>}
                        </>}
                        
                    </>}


                    {/* 海报弹框 */}
                    {sharePosterPopupStatus && <div className={classNames(styles.sharePosterBox, this.isWeixin() ? styles.sharePosterWxBox : '')}>
                        <div className={styles.sharePosterMask} onClick={() => {
                            this.setState({
                                sharePosterPopupStatus: false
                            })
                        }}></div>
                        <div className={styles.shareContentBox} style={{ position: 'relative', zIndex: 89 }}>
                            <>
                                <div
                                    id="posterTarget"
                                    style={{
                                        position: 'absolute',
                                        left: '-9999px',
                                        top: '-9999px',
                                        paddingTop: '34px',
                                        display: 'inline-block'
                                    }}
                                >
                                    <div
                                        className={styles.outerBgBox}
                                        style={{
                                            backgroundImage: this.getImage('bg2') ? `url(${this.getImage('bg2')})` : undefined
                                        }}
                                    >
                                        <div className={styles.innerBox} style={{
                                            backgroundImage: this.getImage('bg15') ? `url(${this.getImage('bg15')})` : undefined
                                        }}>
                                            <div className={styles.innerContent} >
                                                <div className={styles.userAvatarBox}>
                                                    <img src={this.getImage('userAvatar') || this.getImage('icon4')} alt="用户头像" className={styles.userAvatar} />
                                                </div>
                                                <div className={styles.name}>{houseInfo?.user?.nickname || '用户名'}</div>
                                                <div className={styles.info}>我是vivo社区APP <span>{houseInfo?.building || 'D'}</span> 栋 <span>{houseInfo?.unit || '1'}</span> 单元 <span>{houseInfo?.floor || '5'}</span> 楼 <span>{houseInfo?.room || '03'}</span> 室</div>
                                                <div className={styles.title}>
                                                    <div>邀您参与<span> V粉搬新家，领房产证</span></div>
                                                    <div>一起<span>瓜分V币，赢vivo X300</span></div>
                                                </div>
                                                <div className={styles.posterCardImgBox}>
                                                    <img src={this.getImage('bg9')} alt="" className={styles.leftImg} />
                                                    <div className={styles.rightImgBox} style={{
                                                        backgroundImage: this.getImage('bg15') ? `url(${this.getImage('bg15')})` : undefined
                                                    }}>
                                                        <div className={styles.houseCardBox}>
                                                            <div className={styles.houseCardInfo} style={{
                                                                backgroundImage: this.getImage('bg8') ? `url(${this.getImage('bg8')})` : undefined
                                                            }}>
                                                                <div className={styles.cardNum}>不动产权第 {houseInfo?.id} 号</div>
                                                                <img src={this.getImage('icon4')} alt="用户头像" className={styles.userAvatar} />
                                                                <div className={styles.gap}>• 权利人 •</div>
                                                                <div className={styles.info}>{houseInfo?.user?.nickname}</div>
                                                                <div className={styles.gap}>• 坐落 •</div>
                                                                <div className={styles.info}>vivo社区APP <span>{houseInfo?.building}</span> 栋 <span>{houseInfo?.unit}</span> 单元 <span>{houseInfo?.floor}</span> 楼 <span>{houseInfo?.room}</span> 室</div>
                                                                <div className={styles.gap}>• 使用期限 •</div>
                                                                <div className={styles.info}>{houseInfo?.issued_at}-永久</div>
                                                                <div className={styles.cardBottom}>
                                                                    <div className={styles.codeBox}>
                                                                        <div className={styles.downloadCodeBox}>
                                                                            <img src={this.getImage('downloadCode')} alt="" className={styles.code} />
                                                                        </div>
                                                                        <div className={styles.bottomInfo}>
                                                                            <div className={styles.text}>发证方（章）</div>
                                                                            <div className={styles.text}>{houseInfo?.issued_at}</div>
                                                                        </div>
                                                                    </div>
                                                                    <img src={this.getImage('img3')} alt="" className={styles.chapter} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <img src={this.getImage('img2')} alt="" className={styles.prizeIcon} />
                                                </div>
                                                <div className={styles.thanks}>感谢一路有你共建理想家园</div>
                                                <div className={styles.codeTip}>长按识别二维码参与</div>
                                            </div>

                                            <div className={styles.posterBottomBox} style={{
                                                backgroundImage: this.getImage('bg4') ? `url(${this.getImage('bg4')})` : undefined
                                            }}>
                                                <div className={styles.bottomCodeBox} style={{
                                                    backgroundImage: this.getImage('bg6') ? `url(${this.getImage('bg6')})` : undefined
                                                }}>
                                                    <img src={this.getImage('downloadCode')} alt="" className={styles.bottomCode} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* 隐藏生成的海报图片 */}
                                {posterLoaded && posterImage && (
                                    <img
                                        src={posterImage}
                                        alt="生成的海报"
                                        style={{
                                            position: 'absolute',
                                            left: '-9999px',
                                            top: '-9999px',
                                            opacity: 0,
                                            pointerEvents: 'none'
                                        }}
                                    />
                                )}

                                {/* 显示给用户看的海报 */}
                                <div className={styles.outerBgBox}>
                                    <div className={styles.innerBox}>
                                        <div className={styles.innerContent}>
                                            <div className={styles.userAvatarBox}>
                                                <img src={houseInfo?.user?.avatar || `${BASE_IMG_URL}/common/avatar.png`} onError={this.handleImageError} alt="用户头像" className={styles.userAvatar} />
                                            </div>
                                            <div className={styles.name}>{houseInfo?.user?.nickname || '用户名'}</div>
                                            <div className={styles.info}>我是vivo社区APP <span>{houseInfo?.building || 'D'}</span> 栋 <span>{houseInfo?.unit || '1'}</span> 单元 <span>{houseInfo?.floor || '5'}</span> 楼 <span>{houseInfo?.room || '03'}</span> 室</div>
                                            <div className={styles.title}>
                                                <div>邀您参与<span> V粉搬新家，领房产证</span></div>
                                                <div>一起<span>瓜分V币，赢vivo X300</span></div>
                                            </div>
                                            <div className={styles.posterCardImgBox}>
                                                <img src={`${BASE_IMG_URL}/house/bg21.png`} alt="" className={styles.leftImg} />
                                                <div className={styles.rightImgBox}>
                                                    <div className={styles.houseCardBox}>
                                                        <div className={styles.houseCardInfo}>
                                                            <div className={styles.cardNum}>不动产权第 {houseInfo?.id} 号</div>
                                                            <img src={houseInfo?.user?.avatar || `${BASE_IMG_URL}/common/avatar.png`} onError={this.handleImageError} alt="用户头像" className={styles.userAvatar} />
                                                            <div className={styles.gap}>• 权利人 •</div>
                                                            <div className={styles.info}>{houseInfo?.user?.nickname}</div>
                                                            <div className={styles.gap}>• 坐落 •</div>
                                                            <div className={styles.info}>vivo社区APP <span>{houseInfo?.building}</span> 栋 <span>{houseInfo?.unit}</span> 单元 <span>{houseInfo?.floor}</span> 楼 <span>{houseInfo?.room}</span> 室</div>
                                                            <div className={styles.gap}>• 使用期限 •</div>
                                                            <div className={styles.info}>{houseInfo?.issued_at}-永久</div>
                                                            <div className={styles.cardBottom}>
                                                                <div className={styles.codeBox}>
                                                                    <div className={styles.downloadCodeBox}>
                                                                        <img src={qrcodeImage.downloadCode} alt="" className={styles.code} />
                                                                    </div>
                                                                    <div className={styles.bottomInfo}>
                                                                        <div className={styles.text}>发证方（章）</div>
                                                                        <div className={styles.text}>{houseInfo?.issued_at}</div>
                                                                    </div>
                                                                </div>
                                                                <img src={`${BASE_IMG_URL}/house/img3.png`} alt="" className={styles.chapter} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <img src={`${BASE_IMG_URL}/house/img2.png`} alt="" className={styles.prizeIcon} />
                                            </div>
                                            <div className={styles.thanks}>感谢一路有你共建理想家园</div>
                                            <div className={styles.codeTip}>长按识别二维码参与</div>
                                        </div>

                                        <div className={styles.posterBottomBox}>
                                            <div className={styles.bottomCodeBox}>
                                                <img src={qrcodeLetter.code} alt="" className={styles.bottomCode} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {!this.isWeixin() && <div className={styles.saveBtnBox}>
                                    <img src={`${BASE_IMG_URL}/house/close_poster.png`} alt="" className={styles.closePoster} onClick={() => {
                                        this.setState({
                                            sharePosterPopupStatus: false
                                        })
                                    }} />
                                    <div className={styles.saveBtn} onClick={() => {
                                        if (this.state.posterGenerating) {
                                            Toast.info({ content: '正在生成海报，请稍候' });
                                            return;
                                        }
                                        Toast.loading({ content: '海报生成中···' });
                                        this.convertAllImagesToBase64(houseInfo);
                                    }}>
                                        <img src={`${BASE_IMG_URL}/house/icon3.png`} alt="" className={styles.icon} />
                                        <span>保存图片</span>
                                    </div>
                                </div>}

                            </>
                        </div>
                    </div>}

                </div>}
            </>)
    }
}

export default withRouter(HouseCardH5Page);
